import { runPageLoadTime } from 'ccui-shared/legacy-dep-bootstrap/components/page-load-time';

runPageLoadTime('webpack_mark_root');
